/* global I18n */

import {use_configuration} from "./configuration_provider"
import LoadingButton from "../loading_button"
import React from "react"

function QuizModeButton({
  text,
  on_click,
  is_loading = false
}) {
  const {configuration} = use_configuration()
  const {quiz_mode} = configuration
  const selection = {
    excluded_muscle_facts: configuration.excluded_muscle_facts,
    spelling_exercises: configuration.spelling_exercises,
    muscle_facts: configuration.muscle_facts
  }
  if (quiz_mode === "study_mode") {
    selection.duration = configuration.duration
  } else {
    selection.length =
      configuration.length > configuration.max_length
        ? configuration.max_length
        : configuration.length
    if (quiz_mode === "exam_mode") {
      selection.exam_conditions = configuration.exam_conditions
    }
  }
  const has_exercises = quiz_mode === "study_mode" || selection.length > 0

  return (
    <LoadingButton
      className="btn btn-primary quiz-start-btn"
      onClick={(e) => {
        e.stopPropagation()
        return on_click(quiz_mode, selection)
      }}
      is_loading={is_loading}
      disabled={!!is_loading || !quiz_mode || !has_exercises}
      ladda="zoom-out">
      {text || I18n.t("js.quiz_mode_selector.start")}
    </LoadingButton>
  )
}

export default QuizModeButton
